import { createEvent, isDesktop } from '../defs';

export default function initHeader() {
    if (!window.LBRL_HEADERS) {
        return;
    }

    const { mbhEl, dthEl } = window.LBRL_HEADERS;
    const searchEl = document.getElementById('hdrsrch');
    mbhEl && initMobileHeader(mbhEl);
    dthEl && initDesktopHeader(dthEl);
    searchEl && initSearch(searchEl);

    searchEl.inert = true;
}

/**
 * @param {HTMLElement} mbhEl
 */
function initMobileHeader(mbhEl) {
    const searchBtnEl = mbhEl.querySelector('.mbh-searchBtn');
    const menuBtnEl = mbhEl.querySelector('.mbh-menuBtn');
    const menuEl = mbhEl.querySelector('.mbh-menu');
    const mainLvlEl = mbhEl.querySelector('.mbh-mainLvl');
    const secondLvlEl = mbhEl.querySelector('.mbh-secondLvl');
    const backBtn = mbhEl.querySelector('.mbh-backBtn');
    const mainLvlButtonEls = [].slice.apply(mainLvlEl.querySelectorAll('li button'));
    const secondLvlMenuEls = [].slice.apply(secondLvlEl.querySelectorAll('nav'));

    searchBtnEl.addEventListener('click', () => {
        document.dispatchEvent(createEvent('hdrsrch.open'));
    });
    menuBtnEl.addEventListener('click', toggleMenu);

    backBtn.addEventListener('click', hideSecondaryMenu);

    mainLvlButtonEls.forEach((buttonEl, idx) => {
        buttonEl.addEventListener('click', () => showSecondaryMenu(idx));
    });

    function toggleMenu() {
        menuBtnEl.classList.contains('is-active') ? hideMenu() : showMenu();
    }

    function hideMenu() {
        hideSecondaryMenu();
        menuBtnEl.classList.remove('is-active');
        menuEl.classList.remove('is--visible');
    }

    function showMenu() {
        hideSecondaryMenu();
        menuBtnEl.classList.add('is-active');
        menuEl.classList.add('is--visible');
    }

    function hideSecondaryMenu() {
        secondLvlEl.classList.remove('is--visible');
        backBtn.classList.remove('is--visible');
        mainLvlEl.classList.remove('is--previous');
        secondLvlMenuEls.forEach(navEl => {
            navEl.classList.remove('is--active');
        });
    }

    function showSecondaryMenu(idx) {
        const navEl = secondLvlMenuEls[idx];
        if (navEl) {
            backBtn.classList.add('is--visible');
            mainLvlEl.classList.add('is--previous');
            secondLvlEl.classList.add('is--visible');
            navEl.classList.add('is--active');
        }
    }
}

/**
 * @param {HTMLElement} dthEl
 */
function initDesktopHeader(dthEl) {
    const topEl = dthEl.querySelector('.dth-top');
    const bottomEl = dthEl.querySelector('.dth-bottom');
    const extraBtnEl = bottomEl.querySelector('.dth-moreBtn');
    const extraEl = dthEl.querySelector('.dth-extra');
    const searchBtnEl = dthEl.querySelector('.dth-searchBtn');

    extraEl.inert = true;

    initDropDownMenu();
    initCompactView();

    searchBtnEl.addEventListener('click', () => {
        document.dispatchEvent(createEvent('hdrsrch.open'));
    });

    function initDropDownMenu() {
        const hamburgerEl = extraBtnEl.querySelector('.hamburger');

        extraBtnEl.addEventListener('click', toggle);
        document.addEventListener('dth.menu.show', show);
        document.addEventListener('dth.menu.hide', hide);
        document.addEventListener('dth.menu.toggle', toggle);

        document.addEventListener('click', event => {
            isShown() && event.target !== dthEl && !dthEl.contains(event.target) && hide();
        });

        function isShown() {
            return extraEl.classList.contains('is--visible');
        }

        function toggle() {
            isShown() ? hide() : show();
        }

        function show() {
            extraEl.inert = false;
            hamburgerEl.classList.add('is-active');
            extraBtnEl.setAttribute('aria-expanded', 'true');
            extraEl.setAttribute('tabindex', '0');
            extraEl.classList.add('is--visible');
            extraEl.dispatchEvent(createEvent('dth.menu.shown'));
        }

        function hide() {
            extraEl.inert = true;
            hamburgerEl.classList.remove('is-active');
            extraBtnEl.setAttribute('aria-expanded', 'false');
            extraEl.setAttribute('tabindex', '-1');
            extraEl.classList.remove('is--visible');
            extraEl.dispatchEvent(createEvent('dth.menu.hidden'));
        }
    }

    function initCompactView() {
        const FULL_HEIGHT = 140;
        const MIN_HEIGHT = 90;
        const EASING_DISTANCE_MULT = 2;
        const EASING_INTERVAL = EASING_DISTANCE_MULT * (FULL_HEIGHT - MIN_HEIGHT);

        // Start animation immediately if desktop header is in DOM
        let af = (dthEl.parentElement && requestAnimationFrame(animate)) || null;

        // Stop animation when desktop header is hidden
        dthEl.addEventListener('dth.hidden', () => {
            cancelAnimationFrame(af);
        });
        // Restart animation when desktop header is visible again
        dthEl.addEventListener('dth.visible', () => {
            af = requestAnimationFrame(animate);
        });

        function animate() {
            if (window.pageYOffset > EASING_INTERVAL) {
                dthEl.classList.add('is--min');
                dthEl.style.height = '';
            } else if (window.pageYOffset > 0) {
                dthEl.classList.remove('is--min');
                dthEl.style.height = `${FULL_HEIGHT - (window.pageYOffset / EASING_DISTANCE_MULT)}px`;
            } else {
                dthEl.classList.remove('is--min');
                dthEl.style.height = '';
            }
            af = requestAnimationFrame(animate);
        }
    }
}


/**
 * @param {HTMLElement} root
 */
function initSearch(root) {
    const MIN_INPUT_LENGTH = 2;
    const inputEl = document.getElementById('hdrsrch-input');
    const spinnerInnerEl = root.querySelector('.hdrsrch-spinnerInner');
    const resultsWrapperEl = document.getElementById('hdrsrch-resultsWrapper');
    const resultsEl = document.getElementById('hdrsrch-results');
    const closeBtn = document.getElementById('hdrsrch-closeBtn');
    const seeAllEl = document.getElementById('hdrsrch-seeAll');

    let runningQuery = '';

    // open()
    hideSearchResults();

    closeBtn.addEventListener('click', close);
    inputEl.addEventListener('keyup', event => {
        const value = getUserInput();
        seeAllEl.setAttribute('href', value ? `/?s=${encodeURIComponent(value)}` : '');
        if (event.key === 'Enter' && value) {
            seeAllEl.click();
        } else {
            search();
        }
    });

    document.addEventListener('hdrsrch.toggle', toggle);
    document.addEventListener('hdrsrch.open', open);
    document.addEventListener('hdrsrch.close', close);

    root.addEventListener('click', event => {
        if (event.target === root) {
            close();
        }
    });

    function getUserInput() {
        return inputEl.value.trim();
    }

    function hasUserInput() {
        const input = getUserInput();
        return input && input.length >= MIN_INPUT_LENGTH;
    }

    async function search() {
        if (runningQuery) {
            return;
        }

        awaitSearchResults();

        // Wait for user to enter other terms which differ from currently queried terms
        let data = null;
        while (hasUserInput() && getUserInput() !== runningQuery) {
            runningQuery = getUserInput();

            let args = new FormData();
            args.append('action', 'WA_WP_MainController');
            args.append('__handler', 'search');
            args.append('output_type', 'compact');
            args.append('include_page_link', '1');
            args.append('query_args[s]', runningQuery);
            args.append('query_args[posts_per_page]', '10');
            args.append('query_args[post_type][]', 'folkpart_politiker');
            args.append('query_args[post_type][]', 'folkpart_politik');
            args.append('query_args[post_type][]', 'post');
            args.append('query_args[post_type][]', 'page');
            args.append('query_args[post_type][]', 'lokalt_ort');
            args.append('query_args[post_type][]', 'attachment');

            try {
                data = await (await fetch('/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    body: args,
                })).json();
            } catch (err) {
                console.warn(err);
            }
        }

        if (isOpen() && data && data.success && data.payload) {
            displaySearchResults(data.payload);
        }

        if (!hasUserInput() || !isOpen()) {
            hideSearchResults();
        }

        runningQuery = '';
    }

    function displaySearchResults(payload) {
        resultsWrapperEl.classList.remove('is--loading');
        if (payload.results && payload.results.length) {
            resultsEl.innerHTML = payload.results.join('\n');
        } else if (payload.no_results) {
            const tmp = document.createElement('div');
            tmp.innerHTML = payload.no_results;
            resultsEl.appendChild(tmp);
        }
        if (typeof payload.search_page_link === 'string') {
            const tmp = document.createElement('div');
            tmp.innerHTML = payload.search_page_link;
            resultsEl.appendChild(tmp);
        }
        resultsWrapperEl.style.height = resultsEl.scrollHeight + 'px';
    }

    function hideSearchResults() {
        resultsWrapperEl.classList.remove('is--loading');
        resultsWrapperEl.style.height = '0';
        resultsEl.innerHTML = '';
    }

    function awaitSearchResults() {
        hideSearchResults();
        resultsWrapperEl.style.height = spinnerInnerEl.scrollHeight + 'px';
        resultsWrapperEl.classList.add('is--loading');
    }

    function isOpen() {
        return root.classList.contains('is--open');
    }

    function toggle() {
        isOpen() ? close() : open();
        root.dispatchEvent(createEvent('hdrsrch.toggled'));
    }

    function open() {
        root.inert = false;
        isDesktop() && inputEl.focus();
        root.classList.add('is--open');
        root.dispatchEvent(createEvent('hdrsrch.opened'));
    }

    function close() {
        root.inert = true;
        hideSearchResults();
        root.classList.remove('is--open');
        root.dispatchEvent(createEvent('hdrsrch.closed'));
    }
}
